import { Box, Container, styled, Typography } from '@mui/material'
import {
  ErrorType,
  PageLayout,
  PageLayoutProps,
  TopBar,
  TopBarSectionVisibilityType
} from '..'
import { useAPIErrorContent } from './hooks/useAPIErrorContent'
import { ErrorContentType, ErrorData } from './types/errorTypes'

const StyledErrorContentBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexShrink: 1,
  marginTop: '2rem',
  marginBottom: '4rem'
})

const StyledErrorTextBox = styled(Box)({
  marginTop: '1rem'
})

const ErrorContentBox = ({ errorHeader, errorText }: ErrorContentType) => (
  <StyledErrorContentBox>
    <Typography variant="h2">{errorHeader}</Typography>
    <StyledErrorTextBox>{errorText}</StyledErrorTextBox>
  </StyledErrorContentBox>
)

interface TranslatedErrorContentBoxProps {
  errorData: ErrorData
}

const TranslatedErrorContentBox = ({
  errorData
}: TranslatedErrorContentBoxProps) => {
  const { errorHeader, errorText } = useAPIErrorContent(errorData)
  return <ErrorContentBox errorHeader={errorHeader} errorText={errorText} />
}

interface ErrorLayoutWithTopBarProps {
  showTopBar: true
  topBarSectionVisibilityProps: TopBarSectionVisibilityType
}

interface ErrorLayoutWithoutTopBarProps {
  showTopBar: false
}

type ErrorLayoutProps = (
  | ErrorLayoutWithTopBarProps
  | ErrorLayoutWithoutTopBarProps
) &
  Required<Pick<PageLayoutProps, 'showBottomBar'>> &
  TranslatedErrorContentBoxProps & {
    useAdminTool: boolean
  }

export const ErrorLayout = ({
  errorData,
  showBottomBar,
  useAdminTool,
  ...rest
}: ErrorLayoutProps) => {
  const { errorType, error } = errorData
  const isTranslationError = errorType === ErrorType.FETCH_TRANSLATIONS

  return (
    <>
      {rest.showTopBar && !isTranslationError && (
        <TopBar
          useAdminTool={useAdminTool}
          {...rest.topBarSectionVisibilityProps}
        />
      )}
      <PageLayout showBottomBar={showBottomBar && !isTranslationError}>
        <Container>
          {!isTranslationError ? (
            <TranslatedErrorContentBox errorData={errorData} />
          ) : (
            <ErrorContentBox
              errorHeader={error.message}
              errorText={error.message}
            />
          )}
        </Container>
      </PageLayout>
    </>
  )
}
